export default __webpack_public_path__ + "static/media/avatar_113.371a8665.png";